// extracted by mini-css-extract-plugin
module.exports = {"btnText":"Hero_btnText__1gjTi","regiter_btn":"Hero_regiter_btn__20so2","disp":"Hero_disp__2y1ZU"};